import type { UserSettings, UserWithStringifiedSettings } from '../../domain/user';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';
import { stringifyObjectValues } from '../../services/string';

const BASE_URL = `${BASE_API_URL}/user`;

export const userApi = {
  getUser: (signal?: AbortSignal) => HttpClient.get<UserWithStringifiedSettings>(`${BASE_URL}/info`, { signal }),
  getUserNTStatus: (signal?: AbortSignal) =>
    HttpClient.get<{ isAllowed: boolean }>(`${BASE_URL}/nt-status`, { signal }),
  saveUserSettings: (settings: Partial<UserSettings>) =>
    HttpClient.post<void>(`${BASE_URL}/settings`, { settings: stringifyObjectValues(settings) }),
};
